module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SidebarSlider Widget

(function (fox, $) {
	
	fox.registerWidget('WindowScrollHandler', {

		configure: function (argument) {
			this.isDefaultState = true;
			this.topPointPassed = false;
			this.bottomPointPassed = false;

			this.registerOptions('', {
				rootElement: '.wrapper',
				customEnabling: false,
				topOffset: 100,
				bottomOffset: 100
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.topOffset = this.getOption('topOffset') || false;
			this.bottomOffset = this.getOption('bottomOffset') || false;

			this.callParent('init', arguments);
		},

		running: function () {
			if (!this.getOption('customEnabling')) {
				//$(window).on('scroll', {widget: this}, this._handleScroll);
				this.enable();
			}

			this.callParent('running', arguments);
		},

		enable: function () {
			this.disable();

			$(window).on('scroll', {widget: this}, this._handleScroll);
			this.isEnabled = true;
		},

		disable: function () {
			$(window).off('scroll', this._handleScroll);
			this.isEnabled = false;
		},

		isEnabled: function () {
			return this.isEnabled;
		},

		_handleScroll: function (e) {
			var widget = e.data.widget;

			widget.scrolled = widget.getScrolledHeight();
			widget.pageHeight = $(widget.getOption('rootElement')).height();
			widget.windowHeight = $(window).height();

			widget.dispatchEvent('scrolling', {top: widget.scrolled});

			if (widget.topOffset) {
				widget._checkTopOffsetPassing();
			};

			if (widget.bottomOffset) {
				widget._checkBottomOffsetPassing();
			};
		},

		_checkTopOffsetPassing: function () {
			var direction;
			var passed = false;

			if (!this.topPointPassed) {
				if (this.scrolled >= this.topOffset) {
					passed = true;
					this.topPointPassed = true;
					direction = 1
				}
			} else {
				if (this.scrolled < this.topOffset) {
					passed = true;
					this.topPointPassed = false;
					direction = -1;
				}
			}

			if (passed) {
				//console.log('topPointReached', direction)
				this.dispatchEvent('topPointReached', {direction: direction});	
			}
		},

		_checkBottomOffsetPassing: function (argument) {
			var direction;
			var passed = false;
			var total = this.pageHeight - this.scrolled - this.windowHeight;

			if (!this.bottomPointPassed) {
				if (total <= this.bottomOffset) {
					passed = true;
					direction = 1;
					this.bottomPointPassed = true;
				}
			} else {
				if (total > this.bottomOffset) {
					passed = true;
					direction = -1;
					this.bottomPointPassed = false;
				}
			}

			if (passed) {
				this.dispatchEvent('bottomPointReached', {direction: direction});	
			}
		},

		getRootElement: function () {
			this.rootElement = $(widget.getOption('rootElement'));
		},

		getScrolledHeight: function () {
			return window.scrollY || window.pageYOffset; // window.pageYOffset for IE
		},

		setTopOffset: function (offset) {
			this.topOffset = offset;
		},

		setBottomOffset: function (offset) {
			this.bottomOffset = offset;
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/windowScrollHandler.js
// module id = 227
// module chunks = 0